import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import { useTranslation } from "react-i18next";
import ResponsesContent from "../../components/Pages/SurveyResponses";

const { displayName } = config;

export default function SurveyResponses() {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: SurveyResponses`;
  }, []);

  return (
    <Layout title="Responses">
      <ResponsesContent />
    </Layout>
  );
}
